// Some lists keep their first columns in a fixed order (e.g. the Pay Inputs
// lists: Employee, Department, Date). Moves those keys to the front, in the
// given order, and keeps the rest as they were. Keys missing from the list
// (hidden in a view) are skipped. Works on headers or headerConfig entries.
export const withFixedLeadingKeys = (list, fixedKeys) => {
  if (!fixedKeys?.length || !list?.length) return list;
  const fixed = fixedKeys
    .map((key) => list.find((item) => item.key === key))
    .filter(Boolean);
  if (!fixed.length) return list;
  const fixedSet = new Set(fixedKeys);
  return [...fixed, ...list.filter((item) => !fixedSet.has(item.key))];
};
